import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';

/* Common */
import { ScrollAnchor, Button } from "js/components/atoms";

/* Symbols */
import CloseIcon from "symbols/close.svg";

/* Utilities */
import { trans } from 'js/utilities';

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Components */
import ConversionFlowComponentRenderer from './ConversionFlowComponentRenderer';
import ConversionFlowVehicleImage from "./ConversionFlowVehicleImage";
import ConversionFlowSubmit from './ConversionFlowSubmit';
import ConversionFlowSummary from "./ConversionFlowSummary";

export default function ConversionFlowForm({ form, uspsLease, flow, status, doRequest, setStep, handleClose }) {
    const activeStep = flow?.steps.find((step) => step.active);
    const vehicle = flow?.summary?.vehicle;

    const [ modalOpen, setModalOpen ] = useState( false);

    return (
        <>
            <form noValidate onSubmit={form.handleSubmit(() => doRequest({ action: 'submit' }, 'submitting'))}>
                <ScrollAnchor key={activeStep?.position} />
                <FormProvider {...form}>
                    <div className="row gutters-6 gutters-xl-2">
                        <div className={`col-12 col-xl-8`}>
                            <div className="px-6 py-10 p-xl-12 bg-white rounded h-100 shadow-medium bust-out mx-sm-0">
                                <div className="row gutters-x-2 gutters-y-4">
                                    {(flow?.form?.title || flow?.form?.intro) && (
                                        <div className="col-12 mb-1 mb-xl-0">
                                            {flow?.form?.title && (
                                                <h5 className="mb-0">{flow.form.title}</h5>
                                            )}
                                            {flow?.form?.intro && (
                                                <p>{flow.form.intro}</p>
                                            )}
                                        </div>
                                    )}
                                    <ConversionFlowComponentRenderer
                                        flow={flow}
                                        uspsLease={uspsLease}
                                    />

                                    {flow?.flowName ==='test_drive' &&
                                        <div className="col-12">
                                            <p className="text--12">Onze adviseurs nemen contact met u op om de afspraak te bevestigen.</p>
                                        </div>
                                    }

                                    {flow?.form?.buttonLabel && (
                                        <div className="col-12 col-lg-auto">
                                            <ConversionFlowSubmit
                                                flow={flow}
                                                handleClose={handleClose}
                                                disabled={status !== 'idle'}
                                                className={`btn-block mt-1 mt-xl-0 ${(status !== 'idle') ? 'btn--loader' : ''}`}
                                            />
                                        </div>
                                    )}
                                    <div className="btn-summary d-flex flex-grow-1 justify-content-center d-md-none mt-2" align="center">
                                        <Button
                                            theme=""
                                            text={trans('flow.summary.btn.title')}
                                            type="button"
                                            className="text-base text-muted--60"
                                            onClick={() => setModalOpen(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-xl-4 d-none d-md-block">
                            <div className="card bg-white rounded">
                                <div className="card-body p-6 p-xl-8 gap-4 gap-xl-6">
                                    {vehicle && (
                                        <ConversionFlowVehicleImage
                                            vehicle={vehicle}
                                        />
                                    )}
                                    <ConversionFlowSummary
                                        summary={flow?.summary}
                                        vehicle={vehicle}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </FormProvider>
            </form>

            <Modal
                key="summaryModal"
                open={modalOpen}
                title={trans('flow.summary.modal.title')}
                header={null}
                handleClose={() => setModalOpen(false)}
            >

                <div className="d-flex flex-column gap-4 gap-xl-6">
                    {vehicle && (
                        <ConversionFlowVehicleImage
                            vehicle={vehicle}
                        />
                    )}
                    <ConversionFlowSummary
                        summary={flow?.summary}
                        vehicle={vehicle}
                    />
                </div>

                <div className="summary-modal__sticky-button">
                    <Button
                        theme="base"
                        text={trans('flow.summary.modal.btn.title')}
                        icon={{ url: CloseIcon }}
                        onClick={() => setModalOpen(false)}
                    />
                </div>
            </Modal>
        </>
    )
}
